import "./App.css";
import Dictionary from "./Dictionary";

export default function App() {
  return (
    <div className="App">
      <div className="container">
        <header className="App-header"></header>
        <main>
          <Dictionary defaultKeyword="summer" />
        </main>

        <footer className="text-center App-footer">
          This project is coded by Julia Troitska and is{" "}
          <a href="https://github.com/JuliaTroitskaya/dictionary-project">
            open-sourced on GitHub
          </a>
        </footer>
      </div>
    </div>
  );
}
